module.exports = __webpack_public_path__ + "img/employee.06925c9e.png";